import "i18next"
import { defineLocalizationResources, type LocalizationResources } from "@florisoft/framework"
import { en } from "./locales/en"

type FlorisoftUiCatalog = typeof en

declare module "i18next" {
  interface ResourceNamespaceMap {
    "florisoft-ui": FlorisoftUiCatalog
  }
}

export const florisoftUiResources: LocalizationResources<"florisoft-ui"> = defineLocalizationResources({
  namespace: "florisoft-ui",
  resources: {
    // English stays inline because it is the deterministic standalone and fallback UI language.
    en,
    // Non-fallback languages are split into separate chunks and loaded only when selected.
    nl: () => import("./locales/nl").then((module) => module.nl),
  },
})
